import { useEffect, useState } from "react";
import moment from "moment";


const ListCalendarFilter = ({updateFromDate, updateToDate, finalFromDate,finalToDate}) => {
  const [selectedDateFilter, setSelectedDateFilter] = useState("all");


  const dateFilterOptions = [
    { label: "Today", dateOption: "today" },
    { label: "week", dateOption: "currentweek" },
    { label: "Previous Month", dateOption: "previousmonth" },
    { label: "Current Month", dateOption: "currentmonth" },
    { label: "Next Month", dateOption: "nextmonth" },
    { label: "Financial Year", dateOption: "financialYear" },
    { label: "ALL Data", dateOption: "all" },
  ];

   // function for financial year
   function getCurrentFinancialYear() {
    const today = moment();
    const currentYear = today.year();
    const fiscalYearStartMonth = 3; // April is month 3 in moment.js

    const startYear =
      today.month() < fiscalYearStartMonth ? currentYear - 1 : currentYear;

    return { finalFromDate: `${startYear}-04-01`, finalToDate: `${startYear + 1}-03-31` };
  }
  function setFilterDates(dateOption) {
    switch (dateOption) {
      case "today":
        updateFromDate(moment().format("YYYY-MM-DD"));
        updateToDate(moment().format("YYYY-MM-DD"));
        break;
      case "currentweek":
        updateFromDate(moment().clone().startOf("isoweek").format("YYYY-MM-DD"));
        updateToDate(moment().clone().endOf("isoweek").format("YYYY-MM-DD"));
        break;
      case "previousmonth":
        updateFromDate(
          moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD")
        );
        updateToDate(
          moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD")
        );
        break;
      case "currentmonth":
        updateFromDate(moment().startOf("month").format("YYYY-MM-DD"));
        updateToDate(moment().endOf("month").format("YYYY-MM-DD"));
        break;
      case "nextmonth":
        updateFromDate(
          moment().add(1, "month").startOf("month").format("YYYY-MM-DD")
        );
        updateToDate(
          moment().add(1, "month").endOf("month").format("YYYY-MM-DD")
        );
        break;
      case "financialYear":
        const currentFinancialYear = getCurrentFinancialYear();
        console.log(currentFinancialYear); // Output: "2023-2024"
        updateFromDate(moment(currentFinancialYear.finalFromDate).format("YYYY-MM-DD"));
        updateToDate(moment(currentFinancialYear.finalToDate).format("YYYY-MM-DD"));
        break;
      case "all":
        updateFromDate("");
        updateToDate("");
        break;
    }
    console.log("date changesd==============>", finalFromDate, finalToDate);
  }
  return (
    <>
      <div className="form-group responsive-btn-group">
  <div className="btn-group btn-group-sm" role="group">
    {dateFilterOptions.map(({ label, dateOption }, index) => (
      <button
        key={index}
        type="button"
        className={`btn btn-outline-primary border-right-0 ${
          selectedDateFilter === dateOption ? "active" : ""
        }`}
        onClick={() => {
          setSelectedDateFilter(dateOption);
          setFilterDates(dateOption);
        }}
      >
        {label}
      </button>
    ))}
  </div>
</div>

    </>
  );
};

export default ListCalendarFilter;
